import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'tradera/state/services/utils/webapi-base-query';
import { canBeResumed } from './actions/draft-actions';
import type {
    DeleteDraftsApiRequest,
    GetDraftsPageApiResponse
} from 'tradera/state/services/types/webapi-selling-generated';

export enum Tags {
    DRAFT_LIST = 'DRAFT_LIST'
}

export const draftsApi = createApi({
    reducerPath: 'draftsApi',
    baseQuery,
    tagTypes: Object.keys(Tags),
    endpoints: (builder) => ({
        deleteDrafts: builder.mutation<void, DeleteDraftsApiRequest>({
            invalidatesTags: [Tags.DRAFT_LIST],
            query: (parameters) => {
                return {
                    url: '/api/webapi/selling/drafts',
                    method: 'DELETE',
                    body: parameters
                };
            }
        }),
        loadDrafts: builder.query<GetDraftsPageApiResponse, void>({
            providesTags: [Tags.DRAFT_LIST],
            query: () => '/api/webapi/selling/drafts',
            transformResponse: (response: GetDraftsPageApiResponse) => {
                return {
                    ...response,
                    items: response.items?.filter((item) =>
                        canBeResumed(
                            item.draftId,
                            item.draftReason,
                            item.shortDescription,
                            item.longDescription,
                            [
                                {
                                    imageUrl: item.images?.find(
                                        (image) => image.imageUrl
                                    )
                                }
                            ]
                        )
                    )
                };
            }
        })
    })
});

export const { useDeleteDraftsMutation, useLoadDraftsQuery, util } = draftsApi;
